<!--
    Language selector for application
-->
<script setup lang="ts">
// UTILS
import { computed, ref } from 'vue';

/* HELPERS */
import { ALLanguageSelector } from '@af-lib/vue-ui';
import { useLocaleStore } from '@/stores/locales';
import { useGlobalStore } from '@/stores/global';
import { useAuthStore } from '@/stores/auth';
import { usePatchUserMutation } from '@/api/vue-query/users/users.mutations';

const localeStore = useLocaleStore();
const globalStore = useGlobalStore();
const authStore = useAuthStore();

const { mutate: patchUserLocale } = usePatchUserMutation();

/* REF */
const languages = computed(() => localeStore.getAvailableLocales);
const selectedLanguage = ref(localeStore.getCurrentLocale);

function onChange() {
  // Set loading overlay
  globalStore.setLoading(true);
  // Call patch language of authenticated user
  const params = {
    locale_id: selectedLanguage.value.id
  };
  patchUserLocale(
    { uuid: authStore.user.uuid, params },
    {
      onError: () => globalStore.setLoading(false)
    }
  );
}
</script>

<template>
  <ALLanguageSelector v-model="selectedLanguage" :languages="languages" @update:modelValue="onChange" />
</template>
